module.exports = __webpack_public_path__ + "jtails-build/img/no-service.3ca28f9a.svg";